export const CONTACT = {
  name: "Restaurante São João",
  address: "Rua 24 de Junho, Lote 2, 7580-628 Comporta, Portugal",
  phone: "+351 265 497 551",
  phoneHref: "tel:+351265497551",
  phone2: "+351 961 603 143",
  phone2Href: "tel:+351961603143",
  email: "restaurantesaojoao@outlook.pt",
  emailHref: "mailto:restaurantesaojoao@outlook.pt",
  whatsapp: "https://wa.me/351265497551",
  instagram: "https://www.instagram.com/restaurantesaojoao/",
  facebook: "https://www.facebook.com/share/19A9owfone/",
  maps: "https://www.google.com/maps/search/?api=1&query=Restaurante+S%C3%A3o+Jo%C3%A3o+Rua+24+de+Junho+Comporta+Portugal",
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+24+de+Junho,+Lote+2,+7580-628+Comporta,+Portugal&output=embed",
  reservePhone: "+351 960 314 173",
  reservePhoneHref: "tel:+351960314173",
  reserveWa: "351960314173",
};

export const LOGO = `${process.env.PUBLIC_URL}/brand/logo.png`;
export const MENU_PDF = {
  en: `${process.env.PUBLIC_URL}/menu/menu-en.pdf`,
  pt: `${process.env.PUBLIC_URL}/menu/menu-pt.pdf`,
};

const R = `${process.env.PUBLIC_URL}/restaurant`;

export const IMAGES = {
  hero: `${R}/hero-food.jpg`,
  heroSlides: [`${R}/hero-food.jpg`, `${R}/rint-dining.jpg`, `${R}/space-2.jpg`],
  about: { exterior: `${R}/rint-exterior.jpg`, dining: `${R}/rint-dining.jpg` },
  wine: `${R}/rint-wine.jpg`,
  wineSecondary: `${R}/wine-bar.jpg`,
  gallery: [
    { src: `${R}/space-1.jpg`, kind: "restaurant" },
    { src: `${R}/space-2.jpg`, kind: "restaurant" },
    { src: `${R}/space-4.jpg`, kind: "restaurant" },
  ],
};

export const SIGNATURES = [
  { img: `${R}/sig-camarao-tigre.jpg`, pt: "Camarão tigre grelhado de coentrada", en: "Grilled Tiger Prawns with Coriander" },
  { img: `${R}/sig-carabineiros.jpg`, pt: "Carabineiros salteados", en: "Sautéed Scarlet Prawns" },
  { img: `${R}/sig-arroz-carabineiros.jpg`, pt: "Arroz de Carabineiros com amêijoas", en: "Scarlet Prawn Rice with Clams" },
  { img: `${R}/sig-selecao-entradas.jpg`, pt: "Seleção de entradas", en: "Selection of Starters" },
  { img: `${R}/sig-polvo-lagareiro.jpg`, pt: "Polvo à Lagareiro", en: "Octopus à Lagareiro" },
  { img: `${R}/sig-arroz-lagosta.jpg`, pt: "Arroz de Lagosta com Camarão e Amêijoas", en: "Lobster Rice with Prawns & Clams" },
  { img: `${R}/sig-lagosta-frigideira.jpg`, pt: "Lagosta na frigideira", en: "Pan-Fried Lobster" },
  { img: `${R}/sig-cataplana-polvo.jpg`, pt: "Cataplana de Polvo, Tamboril e Marisco", en: "Octopus, Monkfish & Seafood Cataplana" },
  { img: `${R}/sig-robalo-frito.jpg`, pt: "Robalo frito", en: "Fried Sea Bass" },
  { img: `${R}/sig-pregado.jpg`, pt: "Pregado grelhado", en: "Grilled Turbot" },
  { img: `${R}/sig-ostras.jpg`, pt: "Ostras", en: "Oysters" },
  { img: `${R}/sig-lulinhas.jpg`, pt: "Lulinhas grelhadas de coentrada", en: "Grilled Baby Squid with Coriander" },
  { img: `${R}/sig-garoupa.jpg`, pt: "Garoupa na frigideira com Amêijoas e Camarão tigre", en: "Pan-Fried Grouper with Clams & Tiger Prawns" },
  { img: `${R}/sig-ameijoas.jpg`, pt: "Amêijoas à Bulhão Pato", en: "Clams à Bulhão Pato" },
];

export const CONTENT = {
  en: {
    nav: { home: "Home", menu: "Menu", gallery: "Gallery", reserve: "Reserve", contact: "Contact", reserveBtn: "Reserve a Table", viewMenu: "View Full Menu" },
    hero: {
      eyebrow: "Comporta · Alentejo Coast",
      title: "Restaurante\nSão João",
      subtitle: "Fresh Seafood • Traditional Portuguese Cuisine • Family Hospitality",
      tagline: "Fresh Seafood · Authentic Alentejo Experience",
      reserve: "Reserve a Table",
      explore: "Explore Menu",
      ratingLabel: "on Google",
      reviewsLabel: "1,400+ Reviews",
    },
    marquee: ["Charcoal Grilled", "Alentejo Coast", "Sea to Table"],
    about: {
      chapter: "01 — Our Story",
      title: "Our Story",
      captionExterior: "Our Restaurant in Comporta",
      captionDining: "The dining room",
      story: [
        {
          h: "Our Story",
          p: [
            "São João stays true to its roots, celebrating traditional Portuguese cooking with a very clear philosophy: to do things well, with good sense and with soul. It is a way of life passed down from generation to generation — felt as much in the care for the ingredients as in the love put into every dish we serve.",
            "The careful selection of produce — from the freshest fish to the most elegant wine — reflects a constant pursuit of excellence, and of balance between quality, price and generosity at the table.",
            "In a region increasingly full of sophisticated dining, São João stands out for its authenticity. Here, sophistication lies in the simplicity of what is done well in our kitchen. The atmosphere is relaxed and welcoming, like a visit to a family home — no fuss, just good spirits, good food and good wine. That is the invitation we make to everyone who steps through our door.",
          ],
        },
        {
          h: "The Sea at Our Heart",
          p: [
            "Our foundation is, above all, the sea. We work every day with fresh fish and shellfish, and the menu is designed to celebrate that abundance: fresh salads, petiscos, rich and fragrant rice dishes, steaming massinhas and cataplanas, fried or grilled fish, moquecas, well-seasoned meats and vegetarian options.",
            "Every dish is cooked to order, with time and dedication — a pot can take anywhere from thirty minutes to an hour. Nothing is rushed, because flavour takes time. The desserts, like our homemade ice creams, are also made by us, with the same artisanal philosophy.",
          ],
        },
        {
          h: "A Place for Everyone",
          p: [
            "Restaurante São João is, above all, a family place — and that is exactly what we want every guest to feel as they walk through our door.",
            "We welcome couples, families with children, groups of friends and, of course, the indispensable four-legged companions, because here everyone is welcome.",
          ],
        },
      ],
    },
    dishes: {
      chapter: "02 — The Table",
      title: "Signature Dishes",
      lead: "Photographed at São João — the plates our guests return for.",
    },
    wine: {
      chapter: "03 — The Cellar",
      title: "A Cellar of Portugal",
      body: "Our wine wall gathers the great regions of Portugal — the Alentejo's bold reds, crisp Vinho Verde, and refined whites from the coast. Ask our family to pair a bottle with your seafood; it is what we love most.",
      tag: "Alentejo · Douro · Setúbal Peninsula",
    },
    atmosphere: {
      chapter: "04 — The Room",
      title: "A Warm and Authentic Dining Experience",
      lead: "Natural wood, woven chairs, rustic lighting and hand-picked details — a room that feels like home on the Comporta coast.",
    },
    gallery: { chapter: "05 — The Space", title: "Our Restaurant", lead: "Step inside — the seating, wine displays and warm lighting of our dining room.", authentic: "Real photographs of Restaurante São João.", captions: ["The wine room", "Table by the cellar", "Set for dinner"] },
    menu: {
      eyebrow: "Comporta · Alentejo",
      title: "The Menu",
      lead: "Fresh from the Alentejo coast — seafood, cataplanas and the flavours of Portugal. Prices in euros; grilled fish sold per kilo.",
      searchPlaceholder: "Search dishes…",
      all: "All",
      empty: "No dishes match your search.",
      results: "dishes",
      preview: "A taste of the table",
    },
    menuButtons: { label: "See Our Menu", en: "View Menu — English", pt: "Ver Menu — Português" },
    reserve2: {
      chapter: "07 — The Reservation",
      title: "Reserve a Table",
      lead: "Every table is personally confirmed by our family. Choose how you'd like to reach us.",
      whatsapp: "Message on WhatsApp",
      call: "Call to Reserve",
      request: "Request a Table",
      whatsappDesc: "Send your details on WhatsApp.",
      callDesc: "Speak with us directly.",
      requestDesc: "Fill a quick form — we reply on WhatsApp.",
      hoursTitle: "Reservation Hours",
      hoursText: "We accept lunch reservations until 1:00 PM and dinner reservations until 8:00 PM. After these hours, tables are available on a first-come, first-served basis.",
      waTemplate: "Hello Restaurante São João, I would like to make a reservation.\nName:\nDate:\nPreferred time:\nNumber of guests:\nLunch or Dinner:\nSpecial requests:",
      form: {
        name: "Name", phone: "Phone Number", email: "Email (optional)", date: "Date", time: "Preferred Time",
        guests: "Number of Guests", meal: "Lunch or Dinner", lunch: "Lunch", dinner: "Dinner", mealPlaceholder: "Select…",
        special: "Special Request (optional)", submit: "Send Request via WhatsApp",
        note: "This opens WhatsApp with your details filled in — just press send, and our family will personally confirm.",
        intro: "Hello Restaurante São João, I would like to request a table.",
        outro: "Please confirm my reservation. Thank you.",
        labels: { name: "Name", phone: "Phone", email: "Email", date: "Date", time: "Time", guests: "Guests", meal: "Lunch/Dinner", special: "Special request" },
      },
    },
    pet: { title: "Pet Friendly", text: "Well-behaved pets are welcome." },
    heroPet: { label: "Pet Friendly", text: "Well-behaved pets are welcome." },
    reviews: {
      chapter: "06 — The Guests",
      title: "Kind Words",
      items: [
        { text: "Delicious food and a beautifully decorated space. Amazing fresh seafood.", author: "Jessica Soares", meta: "Local Guide · Google" },
        { text: "An amazing restaurant owned by the most nice family. The food was exceptional.", author: "Roxana Gabor", meta: "Google Review" },
        { text: "There are still traditional restaurants in Comporta. The food was excellent.", author: "Vanessa Faustino", meta: "Google Review" },
      ],
    },
    contact: {
      chapter: "08 — The Visit",
      title: "Find Us in Comporta",
      addressLabel: "Address",
      phoneLabel: "Reservations",
      emailLabel: "Email",
      hoursLabel: "Opening Hours",
      hours: ["Fri – Wed · 12:00–16:00 · 19:00–22:00", "Thursday · Closed"],
      kitchenLabel: "Kitchen",
      kitchen: "12:00–15:30 · 19:00–22:00",
      whatsapp: "Message on WhatsApp",
      reserve: "Reserve a Table",
      directions: "Get Directions",
    },
    footer: { tagline: "Traditional Portuguese cuisine on the Alentejo coast.", quick: "Explore", follow: "Follow", rights: "All rights reserved.", creditPrefix: "Website designed & developed by" },
  },
  pt: {
    nav: { home: "Início", menu: "Menu", gallery: "Galeria", reserve: "Reservar", contact: "Contacto", reserveBtn: "Reservar Mesa", viewMenu: "Ver Ementa Completa" },
    hero: {
      eyebrow: "Comporta · Costa Alentejana",
      title: "Restaurante\nSão João",
      subtitle: "Marisco Fresco • Comida tradicional Portuguesa • Hospitalidade de Família",
      tagline: "Marisco Fresco · Autêntica Experiência Alentejana",
      reserve: "Reservar Mesa",
      explore: "Ver Menu",
      ratingLabel: "no Google",
      reviewsLabel: "1.400+ Avaliações",
    },
    marquee: ["Grelhados no carvão", "Costa Alentejana", "Do mar à mesa"],
    about: {
      chapter: "01 — A Nossa História",
      title: "A Nossa História",
      captionExterior: "O nosso Restaurante em Comporta",
      captionDining: "A sala de refeições",
      story: [
        {
          h: "A Nossa História",
          p: [
            "O São João permanece fiel às suas raízes, celebrando a cozinha tradicional portuguesa com uma filosofia muito clara: fazer bem, com juízo e com alma. É um lema de vida transmitido de geração em geração, que se sente tanto no cuidado com os ingredientes como no carinho posto em cada prato servido.",
            "A seleção rigorosa de produtos — do peixe mais fresco ao vinho mais elegante — representa essa busca constante pela excelência e pelo equilíbrio entre qualidade, preço e generosidade à mesa.",
            "Num território cada vez mais repleto de propostas gastronómicas sofisticadas, o São João destaca-se pela sua autenticidade. Aqui, a sofisticação reside na simplicidade do que é bem feito na nossa cozinha. O ambiente é descontraído e acolhedor, como uma visita à casa de família — sem grandes etiquetas, apenas boa disposição, boa comida e bons vinhos. É esse o convite que fazemos a quem por cá entra.",
          ],
        },
        {
          h: "O mar no nosso coração",
          p: [
            "A nossa base é sobretudo o mar. Trabalhamos diariamente com peixe e marisco frescos, e a ementa é pensada para celebrar essa abundância: saladas frescas, petiscos, arrozes ricos e perfumados, massinhas e cataplanas fumegantes, peixe frito ou grelhado, moquecas, carnes bem temperadas e opções vegetarianas.",
            "Cada prato é confecionado no momento, com tempo e dedicação — um tacho pode levar entre 30 minutos a uma hora. Nada é apressado, porque o sabor exige tempo. As sobremesas, tal como os gelados caseiros, são também feitas por nós, com a mesma filosofia artesanal.",
          ],
        },
        {
          h: "Uma Casa Para Todos",
          p: [
            "O Restaurante São João é, acima de tudo, um espaço de família — e é exatamente isso que queremos que cada cliente sinta ao atravessar a nossa porta.",
            "Recebemos casais, famílias com crianças, grupos de amigos e, claro, os indispensáveis companheiros de quatro patas, porque aqui todos são bem-vindos.",
          ],
        },
      ],
    },
    dishes: {
      chapter: "02 — A Mesa",
      title: "Pratos de Assinatura",
      lead: "Fotografados no São João — os pratos a que os nossos clientes voltam.",
    },
    wine: {
      chapter: "03 — A Garrafeira",
      title: "Uma Garrafeira de Portugal",
      body: "A nossa parede de vinhos reúne as grandes regiões de Portugal — os tintos encorpados do Alentejo, o Vinho Verde fresco e os brancos elegantes da costa. Peça à nossa família para harmonizar uma garrafa com o seu marisco; é o que mais gostamos de fazer.",
      tag: "Alentejo · Douro · Península de Setúbal",
    },
    atmosphere: {
      chapter: "04 — A Sala",
      title: "Uma Experiência Acolhedora e Autêntica",
      lead: "Madeira natural, cadeiras de palhinha, luz rústica e detalhes escolhidos a dedo — uma sala que sabe a casa na costa de Comporta.",
    },
    gallery: { chapter: "05 — O Espaço", title: "O Nosso Restaurante", lead: "Entre e conheça — as mesas, as garrafeiras e a luz quente da nossa sala.", authentic: "Fotografias reais do Restaurante São João.", captions: ["A garrafeira", "Mesa junto à garrafeira", "Posta para jantar"] },
    menu: {
      eyebrow: "Comporta · Alentejo",
      title: "A Ementa",
      lead: "Fresco da costa alentejana — marisco, cataplanas e os sabores de Portugal. Preços em euros; peixe grelhado vendido ao quilo.",
      searchPlaceholder: "Procurar pratos…",
      all: "Todos",
      empty: "Nenhum prato corresponde à pesquisa.",
      results: "pratos",
      preview: "Uma amostra da mesa",
    },
    menuButtons: { label: "A Nossa Ementa", en: "View Menu — English", pt: "Ver Menu — Português" },
    reserve2: {
      chapter: "07 — A Reserva",
      title: "Reservar Mesa",
      lead: "Cada mesa é confirmada pessoalmente pela nossa família. Escolha como prefere contactar-nos.",
      whatsapp: "Enviar WhatsApp",
      call: "Ligar para Reservar",
      request: "Solicitar Mesa",
      whatsappDesc: "Envie os seus dados por WhatsApp.",
      callDesc: "Fale connosco diretamente.",
      requestDesc: "Preencha um formulário — respondemos por WhatsApp.",
      hoursTitle: "Horário de Reservas",
      hoursText: "Fazemos reservas para almoço até às 13h e para jantar até às 20h. Depois dessas horas funcionamos somente por ordem de chegada.",
      waTemplate: "Olá Restaurante São João, gostaria de fazer uma reserva.\nNome:\nData:\nHora preferida:\nNúmero de pessoas:\nAlmoço ou Jantar:\nPedidos especiais:",
      form: {
        name: "Nome", phone: "Telefone", email: "Email (opcional)", date: "Data", time: "Hora Preferida",
        guests: "Número de Pessoas", meal: "Almoço ou Jantar", lunch: "Almoço", dinner: "Jantar", mealPlaceholder: "Selecionar…",
        special: "Pedido Especial (opcional)", submit: "Enviar Pedido via WhatsApp",
        note: "Isto abre o WhatsApp com os seus dados preenchidos — basta enviar e a nossa família confirmará pessoalmente.",
        intro: "Olá Restaurante São João, gostaria de solicitar uma mesa.",
        outro: "Por favor confirmem a minha reserva. Obrigado.",
        labels: { name: "Nome", phone: "Telefone", email: "Email", date: "Data", time: "Hora", guests: "Pessoas", meal: "Almoço/Jantar", special: "Pedido especial" },
      },
    },
    pet: { title: "Aceitamos Animais de Estimação", text: "Animais bem-comportados são bem-vindos." },
    heroPet: { label: "Pet Friendly", text: "Animais de estimação bem-comportados são bem-vindos." },
    reviews: {
      chapter: "06 — Os Clientes",
      title: "Palavras Gentis",
      items: [
        { text: "Comida deliciosa e um espaço lindamente decorado. Marisco fresco incrível.", author: "Jessica Soares", meta: "Local Guide · Google" },
        { text: "Um restaurante incrível, de uma família muito simpática. A comida foi excecional.", author: "Roxana Gabor", meta: "Avaliação Google" },
        { text: "Ainda há restaurantes tradicionais na Comporta. A comida estava excelente.", author: "Vanessa Faustino", meta: "Avaliação Google" },
      ],
    },
    contact: {
      chapter: "08 — A Visita",
      title: "Encontre-nos na Villa da Comporta",
      addressLabel: "Morada",
      phoneLabel: "Reservas",
      emailLabel: "Email",
      hoursLabel: "Horário",
      hours: ["Sex – Qua · 12:00–16:00 · 19:00–22:00", "Quinta-feira · Encerrado"],
      kitchenLabel: "Cozinha",
      kitchen: "12:00–15:30 · 19:00–22:00",
      whatsapp: "Falar no WhatsApp",
      reserve: "Reservar Mesa",
      directions: "Como Chegar",
    },
    footer: { tagline: "Cozinha tradicional portuguesa na costa alentejana.", quick: "Explorar", follow: "Seguir", rights: "Todos os direitos reservados.", creditPrefix: "Website concebido e desenvolvido por" },
  },
};
